module.exports = __webpack_public_path__ + "img/DEFAULT_CARD_CHANGED.png";